<div class="padding-small bg-light-grey padding-left-large small">
	<div class="flex center">
		<span class="primary hover" (click)="onBack()">Photographers</span>
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		{{ isNew ? 'New photographer' : 'Photographer details' }}
	</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
	<div class="flex between center m-column m-start margin-bottom">
		<h4>Photographer Details</h4>
		<button class="m-margin-top" (click)="saveChanges()" [disabled]="!photographer || loading">
			<i class="fa-solid fa-save"></i>
			Save Changes
		</button>
	</div>

	@if (photographer) {
		<div class="flex m-column">
			<div class="flex column flex-1">
				<b class="margin-bottom-small primary">General info</b>
				<div class="border radius padding margin-bottom">
					<div class="flex column">
						<div class="flex gap margin-bottom m-column">
							<div class="flex-1 margin-right m-margin-right-none">
								<b>
									Name
									<i class="margin-left-smallest fa fa-lock grey"></i>
									@if (!photographerValidation.firstName) {
										<span class="red margin-left">Required field</span>
									}
								</b>
								<input type="text" class="margin-top-smallest full-width disabled" [ngModel]="photographer.firstName" (ngModelChange)="onFirstNameChange($event)" />
							</div>
							<div class="flex-1">
								<b>
									Surname
									<i class="margin-left-smallest fa fa-lock grey"></i>
									@if (!photographerValidation.lastName) {
										<span class="red margin-left">Required field</span>
									}
								</b>
								<input type="text" class="margin-top-smallest full-width disabled" [ngModel]="photographer.lastName" (ngModelChange)="onLastNameChange($event)" />
							</div>
						</div>
						<div class="margin-bottom">
							<b>
								Created at
								<i class="margin-left-smallest fa fa-lock grey"></i>
							</b>
							<div class="flex margin-top-smallest disabled">
								<input type="text" class="flex-1" [matDatepicker]="createdAtDatePicker" matInput [(ngModel)]="photographer.createdAt" />
								<mat-datepicker #createdAtDatePicker></mat-datepicker>
							</div>
						</div>
						<div class="margin-bottom">
							<b>
								Mail
								<i class="margin-left-smallest fa fa-lock grey"></i>
							</b>
							<input type="text" class="margin-top-smallest full-width disabled" [(ngModel)]="photographer.email" />
						</div>
						<div class="margin-bottom">
							<b>
								Telephone
								<i class="margin-left-smallest fa fa-lock grey"></i>
							</b>
							<input type="text" class="margin-top-smallest full-width disabled" [(ngModel)]="photographer.phoneNumber" />
						</div>
					</div>
				</div>

				<b class="margin-bottom-small primary">Contract details</b>

				<div class="card border radius padding">
					<div class="flex column">
						<div class="flex gap margin-bottom m-column">
							<div class="flex-1 margin-right m-margin-right-none">
								<b>Start date</b>
								<div class="flex margin-top-smallest">
									<input type="text" class="flex-1" [matDatepicker]="startDatePicker" matInput [(ngModel)]="photographer.contractStartDate" />
									<mat-datepicker #startDatePicker></mat-datepicker>
									<button class="radius-left-none m-full-width" (click)="startDatePicker.open()">
										<i class="fa-solid fa-calendar-days small margin-right-smallest"></i>
										Edit
									</button>
								</div>
							</div>
							<div class="flex-1">
								<b>End date</b>
								<div class="flex margin-top-smallest">
									<input type="text" class="flex-1" [matDatepicker]="endDatePicker" matInput [(ngModel)]="photographer.contractEndDate" />
									<mat-datepicker #endDatePicker></mat-datepicker>
									<button class="radius-left-none m-full-width" (click)="endDatePicker.open()">
										<i class="fa-solid fa-calendar-days small margin-right-smallest"></i>
										Edit
									</button>
								</div>
							</div>
						</div>
						<div>
							<b>Brands</b>
							<div class="flex center margin-top-smallest m-column m-start">
								<div class="flex-1 padding-small border">
									@for (brand of photographer.brands || []; track brand.id; let last = $last) {
										{{ brand.name }}
										@if (!last) {
											,
										}
									} @empty {
										-
									}
								</div>
								<button class="radius-left-none m-full-width" (click)="openBrandFilterModal()">
									<i class="fa-solid fa-edit margin-right-small"></i>
									Edit
								</button>
							</div>
						</div>

						<div class="margin-top">
							<b>Status</b>
							<div class="flex center margin-top-smallest m-column m-start">
								<div class="flex-1 padding-small border primary">
									{{ photographer.status?.name || '-' }}
								</div>
								<button class="radius-left-none m-full-width" (click)="openStatusModal()">
									<i class="fa-solid fa-refresh margin-right-small"></i>
									Change status
								</button>
							</div>
						</div>
					</div>
				</div>

				@if (!isNew) {
					<div class="flex column start">
						<button class="bg-red white margin-top margin-bottom" (click)="deletePhotographer()" [disabled]="loading">
							<i class="fa-solid fa-trash margin-right-small"></i>
							Delete photographer
						</button>
					</div>
				}
			</div>

			@if (!isNew) {
				<div class="flex column flex-1 margin-left m-margin-left-none m-margin-top">
					<b class="margin-bottom-small primary">Dashboard</b>
					<div class="border primary-dark radius padding primary margin-bottom">
						<div class="flex between center margin-bottom-smallest m-column m-start">
							<b>Revenue</b>
							<span class="disabled flex center desktop-only">
								View detailed insights
								<i class="fa-solid fa-up-right-from-square small margin-left-smallest"></i>
							</span>
						</div>
						<h3 class="margin-top-smallest">{{ photographer.totalRevenue || 0 | currency: 'EUR' : 'symbol' : '1.0-0' }}</h3>
					</div>

					<div class="flex column border primary-dark radius padding primary margin-bottom">
						<div class="flex between center margin-bottom-smallest m-column m-start">
							<b>Orders</b>
							<span class="hover flex center" (click)="goToPhotographerOrders()">
								View all orders
								<i class="fa-solid fa-up-right-from-square small margin-left-smallest"></i>
							</span>
						</div>

						<div class="grid-6 gap margin-top-small m-wrap">
							<div class="flex-1 bg-light-grey hover radius flex column padding-small" (click)="goToPhotographerOrders(orderStatus.Draft)">
								<h3>{{ photographerDashboardResume.draft }}</h3>
								Draft
							</div>
							<div class="flex-1 bg-green hover radius flex column white padding-small" (click)="goToPhotographerOrders(orderStatus.ReadyForPickup)">
								<h3>{{ photographerDashboardResume.readyForPickup }}</h3>
								Ready for pickup
							</div>
							<div class="flex-1 bg-primary white hover radius flex column white padding-small" (click)="goToPhotographerOrders(orderStatus.ShootCompleted)">
								<h3>{{ photographerDashboardResume.shootCompleted }}</h3>
								Shoot completed
							</div>
							<div class="flex-1 bg-orange hover radius flex column padding-small" (click)="goToPhotographerOrders(orderStatus.InProgress)">
								<h3>{{ photographerDashboardResume.inProgress }}</h3>
								In progress
							</div>
							<div class="flex-1 bg-green hover radius flex column white padding-small" (click)="goToPhotographerOrders(orderStatus.Approved)">
								<h3>{{ photographerDashboardResume.approved }}</h3>
								Approved
							</div>
							<div class="flex-1 bg-red white hover radius flex column white padding-small" (click)="goToPhotographerOrders(orderStatus.Rejected)">
								<h3>{{ photographerDashboardResume.rejected }}</h3>
								Rejected
							</div>
						</div>
					</div>

					<!-- <div class="card border radius padding">
					<div class="flex justify-between center wrap gap margin-bottom">
						<h4>Costs</h4>
						-
					</div>
				</div> -->
				</div>
			} @else {
				<div class="flex-1"></div>
			}

			<div class="mobile-only margin-top">
				<button class="full-width" (click)="saveChanges()" [disabled]="!photographer || loading">
					<i class="fa-solid fa-save"></i>
					Save Changes
				</button>
			</div>
		</div>
	} @else if (!loading) {
		<div class="flex center bg-light-grey padding-largest justify-center">
			<div class="flex column center gap">
				<i class="fa fa-user fa-2xl margin-bottom grey"></i>
				<span>No photographer data found</span>
			</div>
		</div>
	}
</div>

@if (loading) {
	<bt-loader></bt-loader>
}
